import { useContext } from "react";
import ContextConstructor from "./Context";
import { IMyMontepioContext } from "./Context.types";

export default function useMyMontepioContext(): IMyMontepioContext {
  return useContext(ContextConstructor) as IMyMontepioContext;
}
